import { Person } from '../../models/Entities/Person/Person';
import { PersonFilter } from '../../models/Entities/Person/PersonCommands';
import { CommonState } from '../common/state/commonState';

export interface PersonState extends CommonState<Person> {
  lastCreated?: Person;

  // current search criteria applied over the list
  filter: PersonFilter | undefined;

  // fixing person identifiers
  isFixingIdentifiers: boolean;
  successFixingIdentifiers: boolean | undefined;
  failOnFixingIdentifiers: boolean;
}

export const PersonUnloadState: PersonState = {
  isLoadingAll: false,
  successLoadingAll: undefined,
  failOnLoadingAll: false,

  isLoadingOne: false,
  successLoadingOne: undefined,
  failOnLoadingOne: false,

  isAddingNewOne: false,
  successAddingNewOne: undefined,
  failOnAddingNewOne: false,

  isUpdatingOne: false,
  successUpdatingOne: undefined,
  failOnUpdatingOne: false,

  isDeletingOne: false,
  successDeletingOne: undefined,
  failOnDeletingOne: false,

  isFixingIdentifiers: false,
  successFixingIdentifiers: undefined,
  failOnFixingIdentifiers: false,

  filter: undefined,
  list: [],
  error: undefined,
  lastCreated: undefined
};
